import _, { first, result, set } from "lodash";

import { message } from "antd";
import axiosRequest from "../../../axios-request/request.methods";
import moment from "moment";

import { stoageGetter } from "../../../helpers";

export const typeOfImpairmentOptions = [
  { label: 'Blindness', value: 'Blindness' },
  { label: 'Low-Vision', value: 'Low-Vision' },
  { label: 'Leprosy Cured Persons', value: 'Leprosy Cured Persons' },
  { label: 'Hearing Impairment', value: 'Hearing Impairment' },
  { label: 'Locomotor Disability', value: 'Locomotor Disability' },
  { label: 'Dwarfism', value: 'Dwarfism' },
  { label: 'Intellectual Disability', value: 'Intellectual Disability' },
  { label: 'Mental Illness', value: 'Mental Illness' },
  { label: 'Autism Spectrum Disorder', value: 'Autism Spectrum Disorder' },
  { label: 'Cerebral Palsy', value: 'Cerebral Palsy' },
  { label: 'Muscular Dystrophy', value: 'Muscular Dystrophy' },
  { label: 'Alzheimer’s disease and Dementia', value: 'Alzheimer’s disease and Dementia' },
  { label: 'Parkinson’s disease', value: 'Parkinson’s disease' },
  { label: 'Dystonia', value: 'Dystonia' },
  { label: 'ALS (Lou Gehrig’s disease)', value: 'ALS (Lou Gehrig’s disease)' },
  { label: 'Huntington’s disease', value: 'Huntington’s disease' },
  { label: 'Neuromuscular disease', value: 'Neuromuscular disease' },
  { label: 'Multiple sclerosis', value: 'Multiple sclerosis' },
  { label: 'Epilepsy', value: 'Epilepsy' },
  { label: 'Stroke', value: 'Stroke' },
  { label: 'Specific Learning Disabilities', value: 'Specific Learning Disabilities' },
  { label: 'Speech and Language Disability', value: 'Speech and Language Disability' },
  { label: 'Thalassemia', value: 'Thalassemia' },
  { label: 'Hemophilia', value: 'Hemophilia' },
  { label: 'Sickle Cell Disease', value: 'Sickle Cell Disease' },
  { label: 'Acid Attack Victims', value: 'Acid Attack Victims' },
  { label: 'Other', value: 'Other' },
];

export const MEDICAL_TEST_MASTER = {
  "UAA": "3 BP readings at 5 minutes",
  "UAD": "Serum Alkaline Phosphatase",
  "UAG": "Anti-HCV",
  "UAT": "Serum Blood Urea Nitrogen",
  "UAV": "Complete Blood Count - CBC",
  "UAY": "Chest X-ray",
  "UBF": "Complete Blood Profile w/o ESR",
  "UBG": "Complete Blood profile(1)",
  "UBH": "Complete Blood profile(2)",
  "UBL": "Cotinine Test",
  "UBU": "Dobutamine Stress Test",
  "UBV": "Echocardiogram",
  "UBW": "Echocardiogram color Doppler",
  "UBX": "Repeat Electrocardiogram",
  "UBZ": "Erythrocyte Sedimentation Rate",
  "UCH": "Fasting Blood Sugar",
  "UCN": "GGTP test",
  "UCO": "Glycosylated Haemoglobin-HbA1C",
  "UCQ": "H B D H test",
  "UCR": "HBeAG test",
  "UCS": "HDL Cholestrol",
  "UCU": "HIV (Elisa Test)",
  "UCV": "Holter Monitoring test",
  "UDH": "Juvenile Medical Examination",
  "UDK": "Kidney Function Test",
  "UDL": "L D H test",
  "UDN": "Lipid Profile",
  "UDP": "Liver function test",
  "UDS": "Medical Examination",
  "UDV": "Urine Microalbumin",
  "UEJ": "Oral Glucose Tolerance Test",
  "UET": "Post Glucose 2 hours",
  "UEX": "Prostrate Specific Antigen",
  "UEZ": "Pulmonary function test",
  "UFB": "Random Medical",
  "UFK": "Repeat CBP1",
  "UFN": "Repeat Medical Examination",
  "UFO": "Repeat RUA",
  "UFP": "Repeat TMECG",
  "UFR": "Resting Electrocardiogram",
  "UFT": "Rheumatoid factor",
  "UFV": "Routine Urine Analysis",
  "UFW": "Serum Cholestrol",
  "UFX": "Serum Creatinine",
  "UFY": "Serum Triglycerides",
  "UGD": "Serum CPK",
  "UGE": "Serum Potassium",
  "UGF": "Serum Uric Acid",
  "UGH": "SGOT/AST",
  "UGI": "SGPT/ALT",
  "UGR": "Stress Thallium",
  "UGW": "Thyroid function test",
  "UGY": "Total Bilirubin(dir/indir)",
  "UHA": "Total Protein(Albumin&Globulin )",
  "UHC": "Treadmill Electrocardiogram",
  "UHE": "Ultrasound Abdomen",
  "UHF": "Ultrasound KUB",
  "UHG": "Serum Urea",
  "UHQ": "Blood sugar (fasting & PP)",
  "UHR": "Serum Calcium",
  "UHS": "Stress Echocardiogram",
  "UHZ": "Bio Chemistry",
  "UJM": "JME/Tele MER",
  "UME": "ME/Tele MER",
  "UMR": "Video MER of Proposer",
  "URA": "Video MER",
  "URB": "Tele MER",
  "UTA": "BT1",
  "UTB": "BT2",
  "UTC": "BT3",
  "UTD": "BT4",
  "UXA": "Fundoscopy"
};


export const LeadPageFields = {
  PRIMARY_MOBILE_NUMBER: "PRIMARY_MOBILE_NUMBER",
  PRIMARY_EMAIL: "PRIMARY_EMAIL",
  LEAD_TYPE: "LEAD_TYPE",
  PROPOSER_RESIDENTIAL_STATUS: "PROPOSER_RESIDENTIAL_STATUS",
  KYC_AUTHENTTICATION: "KYC_AUTHENTTICATION",
  CKYC_AUTHENTICATION: "CKYC_AUTHENTICATION",
  EKYC_AUTHENTICATION: "EKYC_AUTHENTICATION",
  WOKYC_AUTHENTICATION: "WOKYC_AUTHENTICATION",
  PROPOSER_TITLE: "PROPOSER_TITLE",
  PROPOSER_FIRSTNAME: "PROPOSER_FIRSTNAME",
  PROPOSER_MIDDLENAME: "PROPOSER_MIDDLENAME",
  PROPOSER_LASTNAME: "PROPOSER_LASTNAME",
  PROPOSER_DOB: "PROPOSER_DOB",
  PROPOSER_GENDER: "PROPOSER_GENDER",
  PROPOSER_STATE: "PROPOSER_STATE",
  PROPOSER_CITY: "PROPOSER_CITY",
  PROPOSER_PIN_CODE: "PROPOSER_PIN_CODE",
  PROPOSER_PAN_CKYC: "PROPOSER_PAN_CKYC",
  PRODUCT_OF_INTEREST: "PRODUCT_OF_INTEREST",
  TOP_GOAL_TO_INVEST: "TOP_GOAL_TO_INVEST",
  CALLED_FROM_CKYC_API: "CALLED_FROM_CKYC_API",
  CALLED_FROM_KARZA_API: "CALLED_FROM_KARZA_API",
  CALLED_FROM_LEAD_DETAILS_API: "CALLED_FROM_LEAD_DETAILS_API",
  OVERSEA_MOBILE_NUMBER: "OVERSEA_MOBILE_NUMBER",
  OVERSEA_ADDRESS_LINE_1: "OVERSEA_ADDRESS_LINE_1",
  OVERSEA_ADDRESS_LINE_2: "OVERSEA_ADDRESS_LINE_2",
  OVERSEA_ADDRESS_LINE_3: "OVERSEA_ADDRESS_LINE_3",
  OVERSEA_ADDRESS_LINE_4: "OVERSEA_ADDRESS_LINE_4",
  OVERSEA_COUNTRY: "OVERSEA_COUNTRY",
  OVERSEA_STATE: "OVERSEA_STATE",
  OVERSEA_CITY: "OVERSEA_COUNTRY",
  OVERSEA_PIN_CODE: "OVERSEA_COUNTRY",

  LI_SELECTED_RADIO: "LI_SELECTED_RADIO",
  LI_KYC_AUTHENTICATION: "LI_KYC_AUTHENTICATION",
  LI_AADHARCARD_NUMBER: "LI_AADHARCARD_NUMBER",
  LI_PAN_NUMBER: "LI_PAN_NUMBER",
  LI_EPAN_NUMBER: "LI_EPAN_NUMBER",
  LI_DOB: "LI_DOB",
  //LI_GENDER: "LI_GENDER",
  LI_TITLE: "LI_TITLE",
  LI_PIN_CODE: "LI_PIN_CODE",
  LI_FIRST_NAME: "LI_FIRST_NAME",
  LI_MIDDLE_NAME: "LI_MIDDLE_NAME",
  LI_LAST_NAME: "LI_LAST_NAME",
  LI_COUNTRY: "LI_COUNTRY",
  LI_OTHER_COUNTRY: "LI_OTHER_COUNTRY",
  LI_STATE: "LI_STATE",
  LI_STATE_INTERNATIONAL: "LI_STATE_INTERNATIONAL",
  LI_OTHER_STATE: "LI_OTHER_STATE",
  LI_CITY: "LI_CITY",
  LI_CITY_INTERNATIONAL: "LI_CITY_INTERNATIONAL",
  LI_OTHER_CITY: "LI_OTHER_CITY",
  LI_RESIDENTIAL_STATUS: "LI_RESIDENTIAL_STATUS",
  LI_COUNTRY_CODE: "LI_COUNTRY_CODE",
  LI_OVERSEA_MOBILE: "LI_OVERSEA_MOBILE",
  LI_EMAIL: "LI_EMAIL",
  LI_COUNTRY_OPTIONS: "LI_COUNTRY_OPTIONS",
  LI_STATE_OPTIONS: "LI_STATE_OPTIONS",
  LI_CITY_OPTIONS: "LI_CITY_OPTIONS",
};

export const CallingForConstants = {
  PROPOSER: "PROPOSER",
  LIFE_INSURED: "LIFE_INSURED",
};
// export const mobileNumberRule = (mandatory) => {
//   return [
//     {
//       required: mandatory,
//       message: "Mobile number is required",
//     },
//     {
//       message: "Mobile number should start with 6, 7, 8 or 9 only",
//       pattern: new RegExp(/^[6-9][0-9]{9}$/),
//     },
//   ];
// };

export const namesFieldRule = (mandatory, fieldName) => {
  return [
    {
      required: mandatory,
      message: `${fieldName} is required`,
    },
    {
      // pattern: /^[A-Za-z]+( [A-Za-z]+)*$/, // Validates only alphabets, no special characters or numbers
      pattern: /^[A-Za-z]+(\s+[A-Za-z]+)*$/,
      message: `${fieldName} should contain only alphabets`,
    },
  ];
};

export const mobileNumberRule = (mandatory) => {
  return [
    {
      required: mandatory,
      message: "Mobile number is required",
    },
    {
      pattern: /^[6-9][0-9]{9}$/, // Validates numbers starting with 6-9 and exactly 10 digits
      message: "Mobile number should start with 6, 7, 8, or 9 and have 10 digits",
    },
  ];
};

export const toInputUppercase = (e) => {
  e.target.value = ("" + e.target.value).toUpperCase();
};

export const PANCARD_REGEX = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

export const panCardRule = (mandatory) => {
  return [
    {
      required: mandatory,
      message: "PAN number is required",
    },
    {
      pattern: PANCARD_REGEX,
      message: "Please enter the valid PAN Number",
    },
  ];
};

export const emailRule = (mandatory) => {
  return [
    {
      type: "email",
      message: "Please provide valid email address",
      required: mandatory,
    },
  ];
};

export const onlyMandatoryRule = (fieldName) => {
  return [
    {
      message: `${fieldName} is required`,
      required: true,
    },
  ];
};

export const countryCodeRule = (fieldName) => {
  return [
    // {
    //   message: `${fieldName} is required`,
    //   required: true,
    // },
    {
      pattern: new RegExp(/^\+?[1-9]\d{0,3}$/),
      message: "Please enter a valid country code",
    },
  ];
};

export const aadharCardRule = () => {
  return [
    {
      required: true,
      message: "Aadhar number is required",
    },
    {
      pattern: new RegExp(/^\d{12}$/),
      message: "Please enter a valid 12 digit aadhar number",
    },
  ];
};

export const pincodeRule = (mandatory) => {
  return [
    {
      required: mandatory,
      message: "Pin code is required",
    },
    {
      min: 6,
      max: 6,
      pattern: "^([-]?[1-9][0-9]*|0)$",
      message: "Pin code must be of 6 characters",
    },
  ];
};

export const checkFieldDisability = (fieldName, record, ckycStatus, ckycDetails, ekycStatus, EKYCKDetails, woKycStatus, isUpdateCalled, selectPolicyInsured) => {
  switch (fieldName) {
    case LeadPageFields.PRIMARY_MOBILE_NUMBER:
      return record?.primaryMobile ? true : false;
    case LeadPageFields.PRIMARY_EMAIL:
      return record?.email ? true : false;
    case LeadPageFields.LEAD_TYPE:
      return record?.leadType ? true : false;

    case LeadPageFields.KYC_AUTHENTTICATION:
      if (isUpdateCalled === true) {
        return true;
      } else {
        return ckycStatus === true ? (ckycDetails?.length === 0 ? false : true) : ekycStatus === true ? (record?.EKYCPropserDetails?.length === 0 ? false : true) : woKycStatus === true ? false : false;
      }

    case LeadPageFields.LI_KYC_AUTHENTICATION:
      return ckycStatus === true ? (ckycDetails?.length === 0 ? false : true) : ekycStatus === true ? (EKYCKDetails?.length === 0 ? false : true) : woKycStatus === true ? false : false;

    case LeadPageFields.PROPOSER_PAN_CKYC:
    case LeadPageFields.LI_PAN_NUMBER:
      if (isUpdateCalled === true) {
        return record?.ckycStatus === true ? (record?.ckycDetails?.length === 0 ? false : true) : false;
      } else {
        return ckycStatus === true ? (ckycDetails?.length === 0 ? false : true) : false;
      }

    case LeadPageFields.LI_EPAN_NUMBER:
      return record?.isEPANVerified === true ? true : false;

    case LeadPageFields.LI_AADHARCARD_NUMBER:
      if (isUpdateCalled === true) {
        return record?.EKYCStatus === true ? (record?.EKYCKDetails?.length === 0 ? false : true) : false;
      } else {
        return ekycStatus === true ? (EKYCKDetails?.length === 0 ? false : true) : false;
      }

    case LeadPageFields.PROPOSER_FIRSTNAME:
    case LeadPageFields.PROPOSER_MIDDLENAME:
    case LeadPageFields.PROPOSER_LASTNAME:
    case LeadPageFields.PROPOSER_STATE:
    case LeadPageFields.LI_FIRST_NAME:
    case LeadPageFields.LI_MIDDLE_NAME:
    case LeadPageFields.LI_LAST_NAME:
    case LeadPageFields.LI_STATE:
      if (isUpdateCalled === true) {
        return record?.ckycStatus === true ? (record?.ckycDetails?.length === 0 ? false : true) : record?.EKYCStatus === true ? (record?.EKYCKDetails?.length === 0 ? false : true) : false;
      } else {
        return ckycStatus === true ? true : ekycStatus === true ? true : woKycStatus === true ? false : false;
      }

    case LeadPageFields.PROPOSER_CITY:
    case LeadPageFields.PROPOSER_TITLE:
    case LeadPageFields.LI_CITY:
    case LeadPageFields.LI_TITLE:
      if (isUpdateCalled === true) {
        return record?.ckycStatus === true ? (record?.ckycDetails?.length === 0 ? false : true) : record?.EKYCStatus === true ? false : false;
      } else {
        return ckycStatus === true ? true : ekycStatus === true ? false : woKycStatus === true ? false : false;
      }

    case LeadPageFields.PROPOSER_DOB:
    case LeadPageFields.PROPOSER_PIN_CODE:
    //case LeadPageFields.PROPOSER_GENDER:
    case LeadPageFields.LI_DOB:
    case LeadPageFields.LI_PIN_CODE:
      //case LeadPageFields.LI_GENDER:
      if (isUpdateCalled === true) {
        return record?.ckycStatus === true ? (record?.ckycDetails?.length === 0 ? false : true) : record?.EKYCStatus === true ? (record?.EKYCKDetails?.length === 0 ? false : true) : false;
      } else {
        return ckycStatus === true ? (ckycDetails?.length === 0 ? false : true) : ekycStatus === true ? true : woKycStatus === true ? false : false;
      }

    case LeadPageFields.PROPOSER_RESIDENTIAL_STATUS:
      if (isUpdateCalled === true) {
        return true;
      } else {
        return record?.ckycStatus === true ? (record?.ckycDetails?.length === 0 ? false : true) : record?.EKYCStatus === true ? (record?.EKYCKDetails?.length === 0 ? false : true) : record?.WOEKYCStatus === true ? false : false;
      }

    case LeadPageFields.OVERSEA_MOBILE_NUMBER:
      return isUpdateCalled;

    case LeadPageFields.LI_RESIDENTIAL_STATUS:
    case LeadPageFields.LI_OVERSEA_MOBILE:
    case LeadPageFields.LI_EMAIL:
      if (isUpdateCalled === true && record?._id) {
        return record?.ckycStatus === true
          ? record?.ckycDetails?.length === 0
            ? false
            : true
          : record?.EKYCStatus === true
            ? record?.EKYCKDetails?.length === 0
              ? false
              : true
            : record?.WOEKYCStatus === true
              ? record?.firstName || record?.lastName || record?.dob
                ? true
                : false
              : false;
      } else {
        return false;
      }

    default:
      return false;
  }
};

export const tabMenu = [
  {
    id: "1",
    value: "Status",
  },
  // {
  //   id: "2",
  //   value: "Need Analysis",
  // },
  // {
  //   id: "3",
  //   value: "BI Tracker",
  // },
];

export const generateProposerLiValue = (LeadData, selectPolicyInsured) => {
  if (LeadData?.isUpdateCalled === false) {
    return selectPolicyInsured;
  } else {
    return LeadData?.proposerLi;
  }
};

export const leadTypeOptions = [
  {
    label: "New Business",
    value: "New Business",
  },
  // {
  //   label: "Renewal",
  //   value: "Renewal",
  // },
  // {
  //   label: "Cross Sell",
  //   value: "CrossSell",
  // },
];

export const policyInsuredOptions = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];
export const LeadGender = [
  {
    value: 'M',
    label: "Male",
  },
  {
    value: "F",
    label: "Female",
  },
  {
    value: 'T',
    label: "Transgender",
  },
];

export const residentialStatusOptions = [
  {
    value: "Indian",
    label: "Indian",
  },
  {
    value: "NRI",
    label: "NRI",
  },
  {
    value: "OCI",
    label: "OCI",
  },
  {
    value: "PIO",
    label: "PIO",
  },
];

export const kycAuthenticationOptions = (EKYC_FLAG, residentialStatus, isTermProduct) => {
  // const showWOKYCOption = residentialStatus === "Indian" ? (EKYC_FLAG === true ? false : true) : true;
  const finalResidentialStatus = residentialStatus ? residentialStatus : "Indian";

  const showWOKYCOption = finalResidentialStatus !== "Indian" ? true : EKYC_FLAG === true ? false : !EKYC_FLAG;

  //show EKYC option for all cases:
  const showEkycOption = EKYC_FLAG || isTermProduct || finalResidentialStatus !== "Indian" || finalResidentialStatus === "Indian" ? true : false;

  const options = [
    {
      value: LeadPageFields.EKYC_AUTHENTICATION,
      label: "Proceed with Aadhar KYC",
      showOption: showEkycOption,
    },
    {
      value: LeadPageFields.WOKYC_AUTHENTICATION,
      label: "Proceed without KYC Authentication",
      showOption: showWOKYCOption,
    },
    // {
    //   value: LeadPageFields.CKYC_AUTHENTICATION,
    //   label: "Proceed with CKYC",
    //   showOption: true,
    // },
  ];
  return options;
};

export const proposerTitleOptions = [
  {
    value: "Mr",
    label: "Mr",
  },
  {
    value: "Mrs",
    label: "Mrs",
  },
  {
    value: "Dr",
    label: "Dr",
  },
  {
    value: "Ms",
    label: "Ms",
  },
  {
    value: "Mx",
    label: "Mx",
  },
];

export const generateStatesOptions = (states) => {
  return states && !_.isEmpty(states)
    ? states.map((state) => {
      // ////console.log("map", state);
      const label = state.label;
      const value = state.value;
      const newState = { ...state, label, value };
      // state.push(label)
      return newState;
    })
    : null;
};

export const generateCitiesOptions = (cities) => {
  return cities && !_.isEmpty(cities)
    ? cities?.map((city) => {
      const label = city.label;
      const value = city.label;
      const newCities = { ...city, label, value };
      return newCities;
    })
    : null;
};

export const formatFullName = (firstName, middleName, lastName) => {
  // Remove empty middle name and last name if they are empty

  const formattedMiddleName = middleName ? (middleName.trim() === "" ? "" : ` ${middleName.trim()}`) : "";
  const formattedLastName = lastName ? (lastName.trim() === "" ? "" : ` ${lastName.trim()}`) : "";

  // Concatenate the names and return the formatted full name
  const fullName = `${firstName}${formattedMiddleName}${formattedLastName}`.trim();
  return fullName;
};

export const proposerNamePlaceholder = (ckycStatus, ekycStatus, woKycStatus, fieldName) => {
  switch (fieldName) {
    case LeadPageFields.PROPOSER_FIRSTNAME:
    case LeadPageFields.PROPOSER_MIDDLENAME:
    case LeadPageFields.PROPOSER_LASTNAME:
    case LeadPageFields.PROPOSER_STATE:
    case LeadPageFields.LI_FIRST_NAME:
    case LeadPageFields.LI_MIDDLE_NAME:
    case LeadPageFields.LI_LAST_NAME:
    case LeadPageFields.LI_STATE:
      return ckycStatus === true ? "Auto-populated from PAN" : ekycStatus === true ? "Auto-populated from Aadhar" : woKycStatus === true ? (fieldName === LeadPageFields.PROPOSER_STATE ? "Select" : "Enter") : "Enter";

    case LeadPageFields.PROPOSER_CITY:
    case LeadPageFields.PROPOSER_TITLE:
    case LeadPageFields.LI_CITY:
    case LeadPageFields.LI_TITLE:
      return ckycStatus === true ? "Auto-populated from PAN" : ekycStatus === true ? "Select" : woKycStatus === true ? "Select" : "Select";

    case LeadPageFields.PROPOSER_DOB:
    case LeadPageFields.LI_DOB:
      return ckycStatus === true ? "DD/MM/YYYY" : ekycStatus === true ? "Auto-populated from Aadhar" : woKycStatus === true ? (LeadPageFields.PROPOSER_DOB ? "DD/MM/YYYY" : "Enter") : "Enter";

    case LeadPageFields.PROPOSER_PIN_CODE:
    case LeadPageFields.LI_PIN_CODE:
      return ckycStatus === true ? "Enter" : ekycStatus === true ? "Auto-populated from Aadhar" : woKycStatus === true ? (LeadPageFields.PROPOSER_DOB ? "DD/MM/YYYY" : "Enter") : "Enter";
  }
};

export const formMandatoryField = (fieldName, LeadData, ckycStatus, ekycStatus, woKycStatus) => {
  switch (fieldName) {
    case LeadPageFields.PROPOSER_FIRSTNAME:
      return true;
    case LeadPageFields.PROPOSER_MIDDLENAME:
      return false;
    case LeadPageFields.PROPOSER_LASTNAME:
      return false;
  }
};

export const getDefaultLIObject = (LIdata) => {
  const randomId = Math.floor(Math.random() * 1000); // Generate a random ID
  const newId = `accordion_${randomId}`;
  const newLifeInsured = {
    accordionId: newId,
    EKYCStatus: false,
    WOEKYCStatus: false,
    multiAadharNumber: null,
    multiLiAadharNumberCkyc: null,
    multiAadharLink: null,
    pancardLi: null,
    salutation: null,
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    country: "",
    countryOptions: null,
    otherCountry: "",
    state: "",
    stateOptions: null,
    otherState: "",
    city: "",
    cityOptions: null,
    otherCity: "",
    EKYCKDetails: [],
    selectedLi: LIdata?.length === 0 ? true : false,
    isDeletable: LIdata?.length === 0 ? false : true,
    ckycType: "PAN",
    ckycDetails: [],
    ckycStatus: true,
    birthYear: null,
    pincode: null,
    isOpen: false,
    lifeInsuredResidentialStatus: "Indian",
    overseaCountryCode: "",
    lifeInsuredOverseaNumber: "",
    lifeInsuredEmail: "",
    isEPANVerified: false,
  };

  return newLifeInsured;
};

export const checkValidLifeInsured = (item, EMAIL_FLAG) => {
  console.log("is valid li", item);
  const showError = (msg) => {
    message.error(msg);
    return false;
  };

  if (item.EKYCStatus) {
    return item?.EKYCKDetails?.length !== 0 ? true : showError("EKYC Authentication is required to select this life insured");
  }

  if (item.ckycStatus) {
    return item?.ckycDetails?.length !== 0 ? true : showError("CKYC Authentication is required to select this life insured");
  }

  if (item.WOEKYCStatus) {
    if (!item.firstName) {
      return showError("First name is required to select this life insured");
    }
    if (!item.dob) {
      return showError("Date of birth is required to select this life insured");
    }
    return true;
  }

  if (item.lifeInsuredResidentialStatus !== "Indian" && item.WOEKYCStatus === true) {
    return item.country === "" ? showError("Country is required to select this life insured") : true;
  }

  // if (item.lifeInsuredResidentialStatus !== "Indian") {
  //   return item.overseaCountryCode === "" ? showError("Country code is required to select this life insured") : true;
  // }

  // if (item.lifeInsuredResidentialStatus !== "Indian") {
  //   return item.lifeInsuredOverseaNumber === "" ? showError("Oversea mobile number is required to select this life insured") : true;
  // }

  const isValidEmail = emailRegex.test(item?.lifeInsuredEmail);

  if (item.lifeInsuredResidentialStatus !== "Indian" && checkLIEmailMandatory(item.lifeInsuredResidentialStatus, EMAIL_FLAG) === true) {
    return item.lifeInsuredEmail === "" || isValidEmail === false ? showError("Valid email is required to select this life insured") : true;
  }

  return showError("Please complete available KYC Authentication to select this life insured");
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const checkLIEmailMandatory = (lifeInsuredResidentialStatus, EMAIL_FLAG) => {
  if (lifeInsuredResidentialStatus === "Indian") {
    return EMAIL_FLAG;
  } else {
    return true;
  }
};

export const hitSMSEmailAPI = async (primaryNumber, primaryEmail, userId) => {
  let payloadWithoutEkyc = {
    mobileNo: primaryNumber,
    triggerType: "Ekyc_Yes",
    emailId: primaryEmail,
    userId: userId,
  };
  axiosRequest
    .post("user/sendEkyConsent", payloadWithoutEkyc)
    .then((res) => {
      // console.log("Without Ekyc Res--->", res);
      if (res?.errCode == 1) {
        message.error(res?.errMsg);
      } else {
        message.success(res?.msg);
      }
    })
    .catch((err) => {
      // console.log(err);
    });
};

export const renderEKYCNames = (fieldName, fullName) => {
  switch (fieldName) {
    case LeadPageFields.LI_FIRST_NAME:
      return fullName[0];
    case LeadPageFields.LI_MIDDLE_NAME:
      return fullName.slice(1, -1).join(" ");
    case LeadPageFields.LI_LAST_NAME:
      return fullName[fullName?.length - 1];
    default:
      return "";
  }
};

export const createAddLeadPayload = (mobile, email, proposerFirstNameAddLead, selectPolicyInsured, user_id) => {
  const payload = {
    primaryMobile: mobile,
    email: email,
    LeadType: "New Business",
    user_id: user_id,
    selectPolicyInsuredOption: selectPolicyInsured,
    proposerSalutation: "",
    firstNameProposer: proposerFirstNameAddLead,
    middleNameProposer: "",
    lastNameProposer: "",
    dobProposer: "",
    state: "",
    city: "",
    EKYCPropserDetails: [],
    pancardProposer: "",
    gender: "",
    maritalStatus: "",
    childStatus: "",
    ChildInfo: "",
    address: {
      line1: "",
      line2: "",
      line3: "",
      line4: "",
    },
    country: "",
    pincode: "",
    education: "",
    professionType: "",
    incomeGroup: "",
    district: "",
    profession: "",
    mx_Smoker: "",
  };
  return payload;
};

export const formatPayloadDOB = (proposerDOB) => {
  // Check if proposerDOB is already in dd/mm/yyyy format
  if (typeof proposerDOB === "string" && /\d{2}\/\d{2}\/\d{4}/.test(proposerDOB)) {
    return proposerDOB; // Already in desired format
  }

  // Convert moment object or other date string formats to dd/mm/yyyy
  const formattedDOB = moment(proposerDOB).format("DD/MM/YYYY");

  return formattedDOB;
};

export const createLifeInsuredPayload = (LeadData, LifeInsuredDetails, selectPolicyInsured) => {
  const keysToRemove = ["countryOptions", "stateOptions", "cityOptions"];
  const finalLifeInsuredDetails = removeKeysFromObjects(LifeInsuredDetails, keysToRemove);
  console.log("final life insured details", finalLifeInsuredDetails);

  const hasNumbers = (str) => /\d/.test(str);

  // ✅ Always treat it as array
  const insuredArray = Array.isArray(finalLifeInsuredDetails)
    ? finalLifeInsuredDetails
    : [finalLifeInsuredDetails];

  const hasInvalidName = insuredArray.some(({ firstName, middleName, lastName }) =>
    hasNumbers(firstName) || hasNumbers(middleName) || hasNumbers(lastName)
  );

  if (hasInvalidName) {
    console.error("Name fields should not contain numbers");
    message.error("First name, middle name, and last name must not contain numbers.");
    return null;
  }

  if (LeadData?.isUpdateCalled === false) {
    return selectPolicyInsured === true ? [] : insuredArray;
  } else {
    return insuredArray;
  }
};


// function removeKeysFromObjects(array, keysToRemove) {
//   return array.map((obj) => {
//     const newObj = { ...obj };
//     keysToRemove.forEach((key) => delete newObj[key]);
//     return newObj;
//   });
// }

function removeKeysFromObjects(data, keysToRemove) {
  // Normalize to array for consistent processing
  const arr = Array.isArray(data) ? data : [data];

  const result = arr.map(obj => {
    const newObj = { ...obj };
    keysToRemove.forEach(key => delete newObj[key]);
    return newObj;
  });

  // Return same type as input
  return Array.isArray(data) ? result : result[0];
}


const countryPromiseCache = {};

export const fetchCountries = async (value) => {
  if (!value || value.length < 3) {
    return [];
  }

  if (countryPromiseCache[value]) {
    return countryPromiseCache[value];
  }

  countryPromiseCache[value] = (async () => {
    try {
      const response = await axiosRequest.get(`user/international_masters?country=${value}`);
      let options = response?.map((country) => ({
        value: country?.name,
        label: country?.name,
        states: country?.states,
        phone_code: country?.phone_code,
        iso3: country?.iso3,
      }));
      options = [{ value: "OTHERS", label: "OTHERS", states: [], phone_code: "", iso3: "" }, ...options];
      return options;
    } catch (error) {
      console.error("Error fetching countries:", error);
      delete countryPromiseCache[value];
      return [];
    }
  })();

  return countryPromiseCache[value];
};

export const fetchUserChannel = async () => {
  let userDetails = null;
  const USER = stoageGetter("user");
  let result = await axiosRequest.get(`user/getUser?userId=${USER?.id}`);
  if (result[0]) {
    userDetails = result[0];
  } else {
    userDetails = null;
  }

  return userDetails;
};

export const leadRoutesConstants = {
  STATUS_LEAD: "/leadmasterpage/statuslead",
  NEED_ANALYSIS: "/leadmasterpage/needanalysis/needanalysis",
  BI_TRACKER: "/leadmasterpage/leadtracker",
  ALL_LEADS_HOME: "/leadMaster/all_leads",
};

export const checkUserChannelEKycFlag = async () => {
  const USER = stoageGetter("user");
  let finalEKYCFLAG = USER.channelCode?.ekycFlag;
  const userDetails = await axiosRequest.get(`user/getUser?userId=${USER?.id}`);

  if (userDetails[0]) {
    const channelLevelEKYC = userDetails[0]?.channelCode?.ekycFlag;
    const userLevelEKYC = userDetails[0]?.EkycFlag;
    finalEKYCFLAG = channelLevelEKYC === false ? false : userLevelEKYC;
  }

  return finalEKYCFLAG;
};

export const checkIsLeadDeleted = async (lead_Id) => {
  let isLeadDeleted = false;
  await axiosRequest
    .get(`user/getLeadCheck/${lead_Id}`)
    .then((res) => {
      console.log("result lead delete", res);
      if (res?.errCode === 539) {
        isLeadDeleted = res?.errMsg === "Lead is Present" ? false : true;
      } else {
        isLeadDeleted = true;
      }
    })
    .catch((err) => {
      console.log("error lead check api", err);
    });
  console.log("result lead delete", isLeadDeleted);
  return isLeadDeleted;
};

export const checkLeadMovement = async (movement, LeadData, history) => {
  const isLeadDeleted = await checkIsLeadDeleted(LeadData?.lead_Id);
  const finalEKYCFLAG = await checkUserChannelEKycFlag();
  if (LeadData?._id) {
    if (LeadData?.isUpdateCalled === false) {
      message.warn("Kindly click on Update Lead before proceeding");
      return;
    } else {
      if (LeadData?.proposerResidentialStatus === "Indian") {
        if (finalEKYCFLAG === true) {
          if (LeadData?.EKYCStatus === true || LeadData?.ckycStatus === true) {
            return isLeadDeleted === false ? history.push(movement) : message.error("Lead is deleted. Kindly create a new lead");
          } else {
            return message.error("Please complete either CKYC or EKYC Authentication before proceeding");
          }
        } else {
          return isLeadDeleted === false ? history.push(movement) : message.error("Lead is deleted. Kindly create a new lead");
        }
      } else {
        return isLeadDeleted === false ? history.push(movement) : message.error("Lead is deleted. Kindly create a new lead");
      }
    }
  } else {
    return message.warn("Please create lead before proceeding");
  }
};
